import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Input, Label, Form } from 'reactstrap';
import api from '../../api';
import './index.css';

export default class UserObject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      viewMode: this.props.isCreatingNewUser ? 'edit' : 'view',
      businessPartners: [],
    };
  }
  componentDidMount() {
    this.getBusinessPartners();
  }
  updateObject(attribute, value) {
    const { user } = this.state;
    user[attribute] = value
    this.setState({ user });
  }
  getBusinessPartners() {
    api.fetchAPI({
        method: 'get',
        uri: 'business_partners',
        success: (response) => {
            this.setState({ businessPartners: response.business_partners });
        },
        error: (error) => {
          console.error(error);
        }
    });
  }
  resetPassword() {
    const { user } = this.state;
    const resetPasswordConfirm = window.confirm(`Are you sure to reset ${user.email}'s password?`);
    if (resetPasswordConfirm) {
      api.fetchAPI({
        method: 'post',
        uri: `user/${user.id}/reset_password`,
        body: user,
        success: (response) => {
          if (response.status === 'ok') {
            alert(`User new password is: ${response.new_password}`)
          } else {
            alert('Error');
            console.log(response);
          }
        },
        error: (error) => {
          console.error(error);
        }
      });
    }
  }
  updateUser() {
    const { user } = this.state;
    const { isCreatingNewUser } = this.props;
    api.fetchAPI({
      method: isCreatingNewUser ? 'post' : 'put',
      uri: 'users',
      body: user,
      success: (response) => {
        if (response.status === 'ok') {
          this.setState({ viewMode: 'view', user: response.user });
        } else {
          alert('Error: ' + response.error);
          console.log(response);
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
    this.setState({ viewMode: 'view' });
  }
  deleteUser() {
    const { user } = this.state;
    const deleteCofirm = window.confirm(`Are you sure to delete user ${user.email}? You cannot undo this action.`);
    if (!deleteCofirm) return;
    api.fetchAPI({
      method: 'delete',
      uri: 'users',
      body: user,
      success: (response) => {
        if (response.status === 'ok') {
          this.setState({ user: null });
        } else {
          alert('Error');
          console.log(response);
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
    this.setState({ viewMode: 'view' });
  }
  _renderViewMode() {
    const { user } = this.state;
    return (
      <div className="user-object-main">
        <div className="user-object-top-info">
          <Link to={`/user/${user.id}/permissions`}>
            <h5 className="user-email">{user.first_name} {user.middle_name} {user.last_name}</h5>
            <span>{user.email}</span>
          </Link>
          {user.is_system_admin ?
            <span className="user-object-type-badge">Admin</span>
            :
            null
          }
        </div>
        <div className="user-object-extra-info">
          <div>
            {user.business_partner_name &&
              <p>Partner: {user.business_partner_name}</p>
            }
          </div>
          <FormGroup>
            <Button color="info" onClick={() => this.setState({ viewMode: 'edit' })}>
              Edit
            </Button>{' '}
            <Button color="warning" onClick={() => this.resetPassword()}>
              Reset password
            </Button>{' '}
            <Button color="danger" onClick={() => this.deleteUser()}>
              Delete
            </Button>
          </FormGroup>
        </div>
      </div>
    );
  }
  _renderEditMode() {
    const { user, businessPartners } = this.state;
    const { isCreatingNewUser } = this.props;
    return (
      <div className="user-object-main">
        <div className="user-object-top-info--edit">
          <FormGroup>
            <Input
              value={user.email}
              onChange={(e) => this.updateObject('email', e.target.value)}
              placeholder="Email..."
            />
          </FormGroup>
          {isCreatingNewUser &&
            <FormGroup>
              <Input
                type="password"
                value={user.password}
                onChange={(e) => this.updateObject('password', e.target.value)}
                placeholder="Password"
              />
            </FormGroup>
          }
          <FormGroup>
            <Input
              value={user.first_name}
              onChange={(e) => this.updateObject('first_name', e.target.value)}
              placeholder="First name"
            />
          </FormGroup>
          <FormGroup>
            <Input
              value={user.middle_name}
              onChange={(e) => this.updateObject('middle_name', e.target.value)}
              placeholder="Middle name"
            />
          </FormGroup>
          <FormGroup>
            <Input
              value={user.last_name}
              onChange={(e) => this.updateObject('last_name', e.target.value)}
              placeholder="Last name"
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="select"
              value={user.business_partner_id}
              onChange={(e) => this.updateObject('business_partner_id', e.target.value)}
            >
              {businessPartners.map(partner =>
                <option value={partner.id} key={partner.id}>{partner.name}</option>
              )}
            </Input>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                value={user.is_system_admin}
                checked={user.is_system_admin}
                onChange={(e) => this.updateObject('is_system_admin', e.target.checked)}
              />
                System admin user
            </Label>
          </FormGroup>
        </div>
        <div className="user-object-extra-info">
          <Button
            color="success"
            onClick={() => this.updateUser()}
          >
            {isCreatingNewUser ? 'Create' : 'Save'}
          </Button>
          {' '}
          <Button
            color="secondary"
            onClick={() => this.setState({ viewMode: 'view' })}
          >
            Cancel
          </Button>
        </div>
      </div>
    );
  }
  render() {
    const { viewMode, user } = this.state;
    if (!user) return null;
    if (viewMode === 'view') {
      return this._renderViewMode();
    } else {
      return this._renderEditMode();
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/UserObject/index.js